<template>
  <div class="box" @click="changepinglv">
    <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="button_box"  v-show="is_web_time">
              <Button type="primary"  @click="web_shuaxin2" style="margin-right:5px" icon="ios-refresh"></Button>
              <Button type="primary"  @click="refresh"  class="piliang">{{this.$t('刷新频率')}}</Button>
            </div>
    <Tabs :value="bingji[0]" name="aa" @on-click="change_tab"  :animated="false" >

      <TabPane v-for="(value,k,index) in bingji"  :label="value" :name="value" tab="aa" >
        <!-- 这里显示堆信息 -->
          <div class="dui_box" v-if="dui.battery" style="display:none;">
            <h1 class="dui_title">{{ $t('堆信息') }}</h1>
            <div class="soc_box">
              <Row style="vertical-align: middle;">
                            <Col span="12" v-for="(value,k,index) in dui.battery">
                              <div>{{ $t("Changelang." + value.name_cn) }}：
                                <span class="span_data span_data2">
                                  <template v-if="value.value>=0 && value.value<=10">
                                    <img class="battery_image" :src="imgLogo1" />
                                  </template>
                                  <template v-else-if="value.value>=11 && value.value<=30">
                                    <img class="battery_image" :src="imgLogo2" />
                                  </template>
                                  <template v-else-if="value.value>=31 && value.value<=60">
                                    <img class="battery_image" :src="imgLogo2" />
                                  </template>
                                  <template v-else-if="value.value>=61">
                                    <img class="battery_image" :src="imgLogo4" />
                                  </template>
                                    {{ value.value+value.unit_info }}
                                </span>
                              </div>
                            </Col>
                            <!-- <Col span="12">
                              <div>SOH：
                                <span class="span_data span_data2">
                                  <img class="battery_image" :src="imgLogo" />   {{ dui.battery.value+dui.battery.unit_info }}%
                                </span>
                              </div>
                            </Col>  -->
             </Row>
            </div>

             <div class="info_box"  v-for="(value,k) in dui.other">
              <Row  v-if="k==dui.other.length-1">
                            <Col span="12"  v-for="(value2,k2) in value">
                              <div>{{ $t("Changelang." + value.name_cn) }}：
                                <span class="span_data span_data2 span_data3" :style="'color:'+value2.class"   @click="more(value2.name_cn,value2.more)">
                                  {{ value2.value }}
                                </span>
                              </div>
                            </Col>

             </Row>
             <Row  v-else>
                            <Col span="12"  v-for="(value2,k2,index2) in value">
                              <div>{{ $t("Changelang." + value.name_cn) }}：
                                <span class="span_data span_data2">
                                  <span v-if="value2.name_en == 'voltage' || value2.name_en == 'load_voltage'
  || value2.name_en == 'actual_capacity' || value2.name_en == 'remainder_capacity'
  || value2.name_en == 'charging_capacity_total' || value2.name_en == 'discharge_capacity_total'">
                                    {{ value2.value*value2.xishu+" "+value2.unit_info }}
                                  </span>
                                  <span v-else>
                                    {{ value2.value+" "+value2.unit_info }}
                                  </span>

                                </span>
                              </div>
                            </Col>

             </Row>
             </div>
          </div>

          <Button  v-if="show_caiyang" type="primary"  v-show="is_web_time" class="piliang2"  @click="sampling" >{{$t('采样频率设置')}}</Button>
          <Tabs v-model="currDidTab"  class="tab_inner"  name="bb"  :animated="false" type="line"     @on-click="change_tab2"  >

               <TabPane  v-for="(value,kk,index) in details_data" :key="index" :label="$t('Changelang.' + kk)" :name="kk" tab="bb" >

                <div v-if="rongliang_trends && (kk=='汇总数据' || kk=='PACK详情数据') && value!='nodata'">
                <div v-if="kk=='PACK详情数据' && chans!=''">
                  <Select class="select_box"  @on-change="on_changechan($event)" transfer v-model="pack_check" style="width:150px">
                                <Option  v-for="(item,index) in chans"  :value="item"  :key="item">{{$t('PACK地址')}}：{{ item }}</Option>
                  </Select>
                </div>
                <div style="margin-top:50px;" v-show="is_web_time"><strong  style="color:#000;">{{$t('运行监视')}}</strong></div>
                <div class="tableContent" style="height:600px;" v-show="is_web_time">
                  <div class="button_search">
                <DatePicker  type="date" transfer :value="form_filter3.date"   :placeholder="$t('日期')" style="width: 150px;margin-right:50px;"   @on-change="dateChange2"></DatePicker>
              </div>
                <ChartLineStackMul2 style="height:500px;width:1000px;" :text="$t('运行监视')"
                :color="['#1400FF' ,'#000000','#19741D','#FF7D7D','#00C2FF','#52FF00','#FF8F8F','#FF00E5','#00E0FF']"
                :showTitle="false"
                  :xAxis="alertTimeList3" :value="alertDataList3"  ></ChartLineStackMul2>
              </div>
 <!-- 容量统计 -->
<Row type="flex" align="middle" justify="center" v-show="is_web_time">
          <Col span="24">
            <Card :bordered="false" dis-hover>
              <div class="button_search">
                <DatePicker v-show="is_day" type="date" transfer :value="form_filter2.search_date"  :placeholder="$t('日期')" style="width: 150px;margin-right:10px;"   @on-change="dateChange"></DatePicker>
                <DatePicker v-show="is_month" type="month" transfer :value="form_filter2.search_date"   :placeholder="$t('月份')"   style="width: 150px;margin-right:10px;"   @on-change="dateChange"></DatePicker>
                <DatePicker v-show="is_year" type="year" transfer :value="form_filter2.search_date"   :placeholder="$t('年')" style="width: 150px;margin-right:10px;"   @on-change="dateChange"></DatePicker>

                <Button :class="button1" @click="clicksearchtype(1)">{{$t('前7天')}}</Button>
                <Button :class="button2" @click="clicksearchtype(2)">{{$t('日')}}</Button>
                <Button :class="button3" @click="clicksearchtype(3)">{{$t('月')}}</Button>
                <!-- <Button :class="button4" @click="clicksearchtype(4)">年</Button> -->
              </div>

              <chart-item-bar style="height:300px" :xAxisData="xAxisData3" :seriesData="seriesData3" :legendData="legendData3" :text="textValue"></chart-item-bar>
            </Card>
          </Col>
        </Row>

            </div>
                <div class="box" v-for="(value2,key,index) in value">
                    <div v-if="value2=='nodata'">
                      {{$t('暂无数据')}}
                    </div>
                    <div v-else>
                      <div v-if="key">{{ $t(`Changelang.${key}`) }}</div>
                      <div  v-if="kk=='单体数据'">

                        <Row>
                                <Col span="5">

                                <Select @on-change="on_changechan($event)" transfer v-model="pack_check" style="width:150px">
                                          <Option  v-for="(item,index) in chans"  :value="item"  :key="item">{{$t('PACK地址')}}：{{ item }}</Option>
                                </Select>

                                </Col>
                                <Col span="5">
                                <div>{{$t('pack总压')}}：<span class="" style="color:#999;">{{value2 && value2.pack_voltage ?value2.pack_voltage/100:'' }} v</span></div>
                                </Col>
                                <Col span="5">
                                <div>{{$t('MOS环境温度')}}：<span class="" style="color:#999;">{{ value2 && value2.mos_temperature/10 }} ℃</span></div>
                                </Col>
                                <Col span="5">
                                <div>{{$t('环境温度')}}：<span class="" style="color:#999;">{{ value2 && value2.env_temperature/10 }} ℃</span></div>
                                </Col>
                                <Col span="5">
                                <div>{{$t('电芯温度数量')}}：<span class="" style="color:#999;">{{ value2 && value2.cell_temp_count}}</span></div>
                                </Col>
                                <Col span="5">
                                <div>{{$t('电芯数量')}}：<span class="" style="color:#999;">{{ value2 && value2.cell_count}}</span></div>
                                </Col>
                                </Row>
                            <div>

                          <div class="box"  v-if="value2 && value2.cell_count>0" >
                              <Col span="24">
                                <div><strong  style="color:#000">{{$t('电芯电压')}}</strong></div>
                                </Col>
                      <div class="table_dy_box" style="width:1000px;overflow: scroll;">
                          <Table  :columns="value2.cell_voltage2" :width="value2.cell_count*100"   :data="value2.cell_voltage2_value" >
                            <template slot-scope="{ row }" slot="name">
                              <strong>{{ row.name }}</strong>
                            </template>
                          </Table>
                      </div>

    <Col span="12" style="margin-top:20px;">
                                <div><strong style="color:#000">{{$t('电芯温度')}}</strong></div>
                                </Col>
                    <div class="table_dy_box" style="width:1000px;overflow: scroll;">
                      <Table  :columns="value2.cell_temperature2"  :width="value2.cell_temp_count.length*100"    :data="value2.cell_temperature2_value" >
                          <template slot-scope="{ row }" slot="name">
                            <strong>{{ row.name }}</strong>
                          </template>
                      </Table>
                    </div>
                    <div style="margin-top:50px;"><strong  style="color:#000;">{{$t('电芯电压')}}</strong></div>
                    <div class="tableContent">
                    <ChartLineStackMul2 style="height:500px;width:1000px;" :text="$t('电芯电压')" :color="['#F00']" :showTitle="false" :total="alertTotalList"
                      :xAxis="alertTimeList" :value="alertDataList"  :maxinfo="maxinfo"></ChartLineStackMul2>
                  </div>
                  <div style="margin-top:50px;"><strong  style="color:#000;">{{$t('电芯温度')}}</strong></div>
                  <div class="tableContent">
                    <ChartLineStackMul2 style="height:500px;width:1000px;" :text="$t('电芯温度')" :color="['#FFE500']" :showTitle="false" :total="alertTotalList"
                      :xAxis="alertTimeList2" :value="alertDataList2"  :maxinfo="maxinfo2"></ChartLineStackMul2>
                  </div>

                          </div>


                            </div>

                            </Row>
                      </div>
                   </div>

                   <div class="info_box"   v-if="kk!='单体数据' && value2!='nodata'">

                        <!--老数据 <div>{{ key }}</div>-->
                         <Row>
                            <Col span="24"  v-for="(value,key,index) in value2" v-if="value.name_en!='max_single_volate_bcuaddr' && value.name_en!='max_single_volate_bmuaddr'
  && value.name_en != 'min_single_volate_bcuaddr' && value.name_en != 'min_single_volate_bmuaddr' && value.name_en != 'max_bmu_voltage_bcuaddr' && value.name_en != 'min_bmu_voltage_bcuaddr'
  && value.name_en != 'max_temperature_bcuaddr' && value.name_en != 'max_temperature_bmuaddr' && value.name_en != 'min_temperature_bcuaddr'
  && value.name_en!='min_temperature_bmuaddr' ">
                             <div v-if="value.more">{{ $t("Changelang." + value.name_cn) }} <span class="span_data"><Button type="default" class="gengduobutton" size="small" :style="{ 'color': value.class,'border-color':value.class}" @click="more(value.name_cn,value.more)">
                              {{$t('更多')}}</Button></span></div>
                             <div v-else>
                              <div v-if="kk=='一级数据'">  <!---二级数据-->
                                <div v-if="value.unit_info!=''">
                                 {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ Math.round(value.value*value.xishu * 100) / 100 }} {{ value.unit_info }}</span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_single_volate_celladdr'">
                                 {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[key-2].value }}-BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_single_volate_celladdr'">
                                 {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[key-2].value }}-BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[key-2].value }}-BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[key-2].value }}-BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_bmu_voltage_addr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[1].value }}-BMU{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_bmu_voltage_addr'">
                                 {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BCU{{ value2[5].value }}-BMU{{ value.value }}</span>
                                  </div>


                                  <div v-else>

                                      {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ value.value }}</span>

                                  </div>
                              </div>
                              <div  v-else-if="kk=='汇总数据'">    <!---二级数据-->
                                <div v-if="value.unit_info!=''">
                                   <div class="yuandian"></div>{{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ Math.round(value.value*value.xishu * 100) / 100 }} {{ value.unit_info }}</span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_single_volate_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_single_volate_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else>
                                    <div class="yuandian"></div>{{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ value.value }}</span>
                                  </div>

                              </div>
                              <div  v-else-if="kk=='PACK详情数据'">    <!---二级数据-->
                             <div v-if="value.unit_info!=''">
                                   <div class="yuandian"></div>{{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ Math.round(value.value*value.xishu * 100) / 100 }} {{ value.unit_info }}</span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_single_volate_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_single_volate_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='max_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else-if="value.name_en=='min_temperature_celladdr'">
                                  {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">BMU{{ value2[key-1].value }}-{{ value.value }} </span>
                                  </div>
                                  <div v-else>
                                    <div class="yuandian"></div>{{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ value.value }}</span>
                                  </div>
                              </div>
                              <!-- <div v-else-if="kk=='设备信息' && value=='nodata'" style="border:none">
                                111
                              </div> -->
                              <div v-else-if="kk=='设备信息'  && value!='nodata'">    <!---二级数据-->
                                  <div v-if="key==0" class="deviceTitle">
                                  <div> <img :src="getImageSrc(battery)" alt="" style="width:158px" /></div>
                                  <div><p> {{$t('设备ID')}}: {{did}} <Icon v-if="did" type="md-copy" class="icon" @click="copyToClipboard(did)" /><Icon    v-if="did"  type="md-apps" class="icon" @click="getQrCode(did)" /></p>
                                  <p>{{$t('设备SN')}}: {{SN}} <Icon v-if="SN" type="md-copy" class="icon" @click="copyToClipboard(SN)" /></p>
                                   <p>{{$t('更新时间')}}:{{assign_time}}</p>
                                  </div>
                                  <div style="marginRight:30px"><img :src="qr_url" alt="" style="width:300px" v-if="qr_boolean">
                                  <div v-show="qr_boolean==false"  id="container" style="width: 300px; height: 300px;"></div>
                                  </div>
                                 </div>
                                  <span v-if="!value.type">
                                  <span v-if="value.name_en=='dcac_canid'">
                                    <div class="yuandian"></div> {{ $t("Changelang." + value.name_cn) }}：
                                    <span class="span_data" v-if="can_lineData.length>0">
                                      <Select v-model="formModel.dcac_canid" transfer  filterable :placeholder="$t('CAN逆变器')" style="width:150px" @on-change="(event)=>nibianqi_change(event,'can')">
                                        <Option v-for="(item,i) in can_lineData" :key="i" :value="item.value">{{ local == 'zh-CN' ? item.protocol_name : item.protocol_name_en }}</Option>
                                      </Select>
                                    </span>
                                    <span v-else class="span_data">
                                       <span v-if="value.value==0"> {{
                                  $t("Changelang." + value.value)
                                }}</span>
                                      <span v-else>{{
                                  $t("Changelang." + value.value)
                                }}</span>
                                    </span>
                                  </span>
                                  <span v-else-if="value.name_en=='dcac_comid'">
                                    <div class="yuandian"></div> {{ $t("Changelang." + value.name_cn) }}：
                                    <span class="span_data" v-if="chuan_lineData.length>0">
                                      <Select v-model="formModel.dcac_comid" transfer  filterable :placeholder="$t('串口逆变器')" style="width:150px" @on-change="(event)=>nibianqi_change(event,'chuan')">
                                        <Option v-for="(item,i) in chuan_lineData" :key="i" :value="item.value">{{ local == 'zh-CN' ? item.protocol_name : item.protocol_name_en }}</Option>
                                      </Select>
                                    </span>
                                    <span v-else class="span_data">
                                      <span v-if="value.value==0">{{ value.value }}</span>
                                      <span v-else>{{ value.value }}</span>
                                    </span>
                                  </span>
                                  <span v-else-if="value.name_en=='dcac_netid'">
                                    <div class="yuandian"></div> {{ $t("Changelang." + value.name_cn) }}：
                                    <span class="span_data" v-if="wang_lineData.length>0">
                                      <Select v-model="formModel.dcac_netid" transfer  filterable :placeholder="$t('网络逆变器')" style="width:150px" @on-change="(event)=>nibianqi_change(event,'wang')">
                                        <Option v-for="(item,i) in wang_lineData" :key="i" :value="item.value">{{ local == 'zh-CN' ? item.protocol_name : item.protocol_name_en }}</Option>
                                      </Select>
                                    </span>
                                    <span v-else class="span_data">
                                      <span v-if="value.value==0">{{ value.value }}</span>
                                      <span v-else>{{ value.value }}</span>
                                    </span>
                                  </span>
                                  <span v-else>
                                    <div class="yuandian"></div> {{ $t("Changelang." + value.name_cn) }}：<span class="span_data">{{ value.value }} </span>
                                  </span>
                                </span>

                              </div>
                              <div v-else-if="kk=='固件升级'">
                                <div class="box2">
                                  <!-- <div class="uploadBtn" v-if="is_update===0"><strong>当前已是最新版本</strong></div>
                                  <Button type="primary" class="jiance" @click="check_new">检测新版本</Button>
                                  <div class="uploadBtn" v-if="is_update===1"><Button type="primary"
                                     :loading="uploadLoading" @click="uploadFirmware">开始更新固件</Button></div> -->
                                     <div v-for="(value,key,index) in firmware_list" class="div_ota">
                                          <div v-if="value.is_update==0">
                                             <div class="uploadBtn" v-if="value.is_update===0" style="display:inline-block;">
                                              <strong>{{$t('通道')}}{{ value.chan_id }}：{{$t('当前已是最新版本')}}</strong>
                                              <br>
                                              <Button  type="primary" class="jiance" @click="check_new(value.chan_id)">{{$t('检测新版本')}}</Button>
                                            </div>

                                          </div>
                                          <div  class="div_ota" v-else>
                                            <div class="uploadBtn" style="display:inline-block;">
                                               <strong>{{$t('通道')}}{{ value.chan_id }}：{{$t('检测到新固件')}}{{ value.firmware_ver.firmware_ver }}</strong>
                                               <br>
                                               <Button   type="primary"
                                              @click="uploadFirmware(value.chan_id)" class="jiance" v-if="value.is_shengji">  {{$t('立即升级')}}</Button>
                                              <!-- <Button   type="primary"
                                              @click="progress(value.chan_id)" class="jiance" >进度测试</Button>  -->
                                              <div class="progress" v-if="value.is_jindu">
                                                <span class="progress_text">{{$t('升级进度')}}:{{ $t(value.progress_text) }}</span>
                                                  <Progress :percent="value.progress_percent" :stroke-width="20" text-inside />
                                              </div>
                                              </div>

                                            </div>
                                     </div>
                                </div>
                              </div>
                                    <div v-else-if="kk == '参数设置' &&key==0" >
                                      <Control></Control>
                                    </div>
                        <div v-else-if="kk == '历史记录' &&key==0" style="width:100%" >
                      <DistributionLog :hasDid="1"></DistributionLog>
                        </div>
                        <div v-else-if="kk == '告警数据' &&key==0">
                          <AlermDes :hasDid="1"></AlermDes>
                        </div>
                        <div v-else-if="kk == '历史轨迹' &&key==0">
                             <Historyrouter></Historyrouter>
                        </div>
                        <div v-else-if="kk == '密码管理' &&key==0">
                            <Input :type="passwordType" :icon="passwordTypeIcon" @on-click="swicthPassword" style="width:200px;marginRight:15px;"  :placeholder="$t('devicelist.inputnewpass')" v-model="password"/>
                                            <Button type='primary' @click="savepassword">{{$t('保存')}}</Button>
                        </div>
                             </div>
                            </Col>
                        </Row>
                      </div>

                        <!-- <div v-if="key=='状态'">123</div> -->
                  </div>
               </TabPane>
         </Tabs>
      </TabPane>

  </Tabs>
  <Modal
        :title="$t('刷新频率更改')"
        v-model="modal7"
        :closable="false"
        @on-ok="modal7Ok"
        @on-cancel="modal7cancel"
        :mask-closable="false">
        <p>{{$t('长时间未操作')}}</p>
    </Modal>
  </div>

</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import samplingCustom from "./components/samplingCustom";
import refreshCustom from "./components/refreshCustom";
import moreCustom from "./components/moreCustom";
import Historyrouter from "../historyrouter/historyrouter";
import DistributionLog from "../devicedistribution/distributionLog";
import Control from "../control/control.vue";
import AlermDes from "../../alarmManage/alermDes/alermDes.vue";
import logoImg1 from "@/assets/images/battery1.png";
import logoImg2 from "@/assets/images/battery2.png";
import logoImg3 from "@/assets/images/battery3.png";
import logoImg4 from "@/assets/images/battery4.png";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import echarts from "echarts";
import { formatYMD } from "@/libs/util";
import {
  progress_firmware,
  iotdatalastget,
  get_rl_trends,
  get_yx_trends,
  web_issue_order,
  get_firmware_info,
  upup_firmware,
  config_caiyang_pinglv,
  config_nibianqi,
  get_now_lnglat,
  did_config_pass
} from "@/api/jingxiaoshang";
import { get_qr_code } from "@/api/chuku";
import axios from "axios";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      currDidTab: "",
      map: null,
      qr_boolean_click: false,
      qr_boolean: false, //是否显示二维码
      qr_url: null, //二维码地址
      battery: null, //电池
      SN: null, //设备SN
      assign_time: null, //更新时间
      deviclposition: [], //设备位置
      changepl: 0,
      modal7: false,
      result_firmware: [],
      pack_check: 1,
      password: null,
      passwordTypeIcon: "ios-eye",
      passwordType: "password",
      pack_data: [],
      pack_data_dt: [], //单体数据
      chans: [],
      is_web_time: 1,
      progress_text: "",
      is_shengji: 1,
      is_jindu: 0,
      progress_percent: 0,
      progress_dingshi: null,
      dp_chan_list: [{ value: 0 }],
      maxinfo: 0,
      maxinfo2: 0,
      alertTotalList: 0,
      alertTimeList: [],
      alertDataList: [],
      alertTimeList2: [],
      alertDataList2: [],
      alertTimeList3: [],
      alertDataList3: [],
      is_day: 0,
      is_month: 0,
      is_year: 0,
      textValue: this.$t("容量分析"),
      button1: "new_button_check",
      button2: "new_button",
      button3: "new_button",
      button4: "new_button",
      legendData3: [],
      xAxisData3: [],
      seriesData3: [],
      rongliang_trends: [],
      check_did: "",
      firmware_list: [],
      spinShow: true,
      show_caiyang: false,
      dui: {},
      bingji: [],
      imgLogo1: logoImg1,
      imgLogo2: logoImg2,
      imgLogo3: logoImg3,
      imgLogo4: logoImg4,
      can_lineData: [],
      chuan_lineData: [],
      local: "zh-CN",
      wang_lineData: [],
      dingshi: null,
      shuaxin: 60,
      caiyang_pinglv: 0,
      uploadLoading: false,
      details_data: [],
      did: "",
      buttonSize2: "BMU1",
      buttonSize1: "BCU1",
      charge:0,
      discharge:0,
      columns11: [
        {
          title: "",
          //    slot: 'name',
          key: "name"
        },
        {
          title: "1",
          key: "a1"
        },
        {
          title: "2",
          key: "a2"
        },
        {
          title: "3",
          key: "a3"
        },
        {
          title: "4",
          key: "a4"
        },
        {
          title: "5",
          key: "a5"
        },
        {
          title: "6",
          key: "a6"
        },
        {
          title: "7",
          key: "a7"
        },
        {
          title: "8",
          key: "a8"
        }
      ],
      data11: [
        {
          name: "电压",
          a1: "1.1V",
          a2: "1.1V",
          a3: "1.1V",
          a4: "1.1V",
          a5: "1.1V",
          a6: "1.1V",
          a7: "1.1V",
          a8: "1.1V"
        }
      ],
      data12: [
        {
          name: "温度",
          a1: "1.1V",
          a2: "1.1V",
          a3: "1.1V",
          a4: "1.1V",
          a5: "1.1V",
          a6: "1.1V",
          a7: "1.1V",
          a8: "1.1V"
        }
      ],
      data13: [
        {
          name: "端子温度",
          a1: "1.1V",
          a2: "1.1V",
          a3: "1.1V",
          a4: "1.1V",
          a5: "1.1V",
          a6: "1.1V",
          a7: "1.1V",
          a8: "1.1V"
        }
      ],

      devicename: "aaaaaaaa",
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "参数名",
          key: "param_name"
        },
        {
          title: "当前值",
          key: "now_value"
        },
        {
          title: "设置值",
          key: "config_value",
          slot: "action"
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.index);
                    }
                  }
                },
                "发送"
              )
            ]);
          }
        }
      ],
      data1: [
        {
          id: 1,
          param_name: "单体高压1_保护值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压1_保护延时",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压1_保护恢复值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压1_保护恢复延时",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压2_保护值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压2_保护延时",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压2_保护恢复值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压2_保护恢复延时",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压3_保护值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压3_保护延时",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压3_保护恢复值",
          now_value: 18,
          config_value: 22
        },
        {
          id: 1,
          param_name: "单体高压3_保护恢复延时",
          now_value: 18,
          config_value: 22
        }
      ],
      show1_1: true,
      show1_2: true,
      show1_3: true,
      is_update: 100,
      tabData: [
        { name: "单体高压", value: 1 },
        { name: "单体低压", value: 2 },
        { name: "总体高压", value: 3 },
        { name: "总体低压", value: 4 },
        { name: "充电过流", value: 5 },
        { name: "放电过流", value: 6 },
        { name: "充电高温", value: 7 },
        { name: "充电低温", value: 8 },
        { name: "放电高温", value: 9 },
        { name: "放电低温", value: 10 },
        { name: "充电温差", value: 11 },
        { name: "放电温差", value: 12 },
        { name: "电芯温升", value: 13 },
        { name: "SOC高", value: 14 },
        { name: "SOC低", value: 15 },
        { name: "正极绝缘漏电", value: 16 },
        { name: "负极绝缘漏电", value: 17 },
        { name: "环境高温", value: 18 },
        { name: "环境低温", value: 19 },
        { name: "充电压差", value: 20 },
        { name: "放电压差", value: 21 },
        { name: "端子高温", value: 22 },
        { name: "风扇控制", value: 23 },
        { name: "电芯故障", value: 24 },
        { name: "满充参数", value: 25 },
        { name: "均衡参数", value: 26 },
        { name: "容量", value: 27 },
        { name: "短路保护", value: 28 },
        { name: "掉电开关", value: 29 },
        { name: "继电器控制", value: 30 },
        { name: "基础控制", value: 31 },
        { name: "保护功能", value: 32 }
      ],
      form_filter: {
        tabname: null
      },
      form_filter2: {
        search_type: 1,
        search_date: null
      },
      form_filter3: {
        date: null
      },
      formModel: {
        dp_chan: 0,
        dcac_canid: null,
        dcac_comid: null,
        dcac_netid: null
      },
      tab_check: "",
      //共用的查询与重置
      topButtonList: [
        {
          name: "查询",
          type: "primary",
          method: this.search
        },
        {
          name: "重置",
          type: "error",
          method: this.reset
        }
      ]
    };
  },
  components: {
    ChartPie,
    ChartItemBar,
    ChartLineStackMul2,
    DistributionLog,
    AlermDes,
    Historyrouter,
    Control
  },

  methods: {
    on_changechan(val) {
      this.details_data["PACK详情数据"] = this.pack_data[val - 1];
      this.details_data["单体数据"][""] = this.pack_data_dt[val - 1];
      this.get_yx_trends();
      this.get_rl_trends();

      let res2 = { body: { 单体数据: { "": this.pack_data_dt[val - 1] } } };
      this.zhexian(res2);
    },
    zhexian(res) {
      this.alertTimeList.splice(0);
      this.alertDataList.splice(0);

      this.alertTimeList2.splice(0);
      this.alertDataList2.splice(0);
console.log('SDAD',this.is_web_time);

      if (this.is_web_time == 1) {
        //趋势数据
        let tem1 = [];
        let x_axis = 0;
        let xzhou = [];
        //  alert(res.body['单体数据'][""].cell_voltage[2]);
        if (res.body["单体数据"][""]) {
          for (
            let i = 0;
            i < res.body["单体数据"][""].cell_voltage.length;
            i++
          ) {
            let list = res.body["单体数据"][""].cell_voltage[i];
            tem1.push(list);
            this.maxinfo = res.body["单体数据"][""].ghll.dianya_high + 2000;
            x_axis = i + 1;
            console.log("x_axis", x_axis);
            xzhou.push(x_axis);
          }
          this.alertTimeList = xzhou;
          this.alertDataList.push({
            name: this.$t("电芯电压") + "（mv）",
            data: tem1,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true,

            markLine: {
              symbol: "none", // 去掉辅助线首尾圆点和箭头
              lineStyle: {
                color: "#999",
                type: "dashed" // 实线
              },
              data: [
                {
                  yAxis: res.body["单体数据"][""].ghll.dianya_high, // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: this.$t("最高限制")
                  }
                },
                {
                  yAxis: res.body["单体数据"][""].ghll.dianya_low, // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: this.$t("最低限制")
                  }
                }
              ]
            }
          });
          //趋势数据
          let tem2 = [];
          let x_axis2 = 0;
          let xzhou2 = [];
          //  alert(res.body['单体数据'][""].cell_voltage[2]);
          for (
            let i = 0;
            i < res.body["单体数据"][""].cell_temperature.length;
            i++
          ) {
            let list2 = res.body["单体数据"][""].cell_temperature[i];
            tem2.push(list2 / 10);
            this.maxinfo2 = Math.max(...tem2) + 20;
            x_axis2 = i + 1;
            console.log("x_axis2", x_axis2);
            xzhou2.push(x_axis2);
          }
          this.alertTimeList2 = xzhou2;
          console.log("x_axis2", xzhou2);
          this.alertDataList2.push({
            name: this.$t("电芯温度") + "（℃）",
            data: tem2,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true
          });
        }
      }else{
        //趋势数据
        let tem1 = [];
        let x_axis = 0;
        let xzhou = [];
        //  alert(res.body['单体数据'][""].cell_voltage[2]);
        console.log('SDAD',res.body["单体数据"][0].cell_voltage);
        if (res.body["单体数据"][0]) {
          for (
            let i = 0;
            i < res.body["单体数据"][0].cell_voltage.length;
            i++
          ) {
            let list = res.body["单体数据"][0].cell_voltage[i];
            tem1.push(list);
            this.maxinfo = res.body["单体数据"][0].ghll.dianya_high + 2000;
            x_axis = i + 1;
            console.log("x_axis", x_axis);
            xzhou.push(x_axis);
          }
          this.alertTimeList = xzhou;
          this.alertDataList.push({
            name: this.$t("电芯电压") + "（mv）",
            data: tem1,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true,

            markLine: {
              symbol: "none", // 去掉辅助线首尾圆点和箭头
              lineStyle: {
                color: "#999",
                type: "dashed" // 实线
              },
              data: [
                {
                  yAxis: res.body["单体数据"][0].ghll.dianya_high, // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: this.$t("最高限制")
                  }
                },
                {
                  yAxis: res.body["单体数据"][0].ghll.dianya_low, // 纵坐标的值，决定横向辅助线在y轴的位置
                  label: {
                    formatter: this.$t("最低限制")
                  }
                }
              ]
            }
          });
          //趋势数据
          let tem2 = [];
          let x_axis2 = 0;
          let xzhou2 = [];
          //  alert(res.body['单体数据'][""].cell_voltage[2]);
          for (
            let i = 0;
            i < res.body["单体数据"][0].cell_temperature.length;
            i++
          ) {
            let list2 = res.body["单体数据"][0].cell_temperature[i];
            tem2.push(list2 / 10);
            this.maxinfo2 = Math.max(...tem2) + 20;
            x_axis2 = i + 1;
            console.log("x_axis2", x_axis2);
            xzhou2.push(x_axis2);
          }
          this.alertTimeList2 = xzhou2;
          console.log("x_axis2", xzhou2);
          this.alertDataList2.push({
            name: this.$t("电芯温度") + "（℃）",
            data: tem2,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true
          });
        }
      }
    },
    dateChange(val) {
      //alert(val)
      if (val) {
        this.$set(this.form_filter2, "search_date", val);
        this.get_rl_trends();
      }
    },
    dateChange2(val) {
      //alert(val)
      if (val) {
        this.$set(this.form_filter3, "date", val);
        this.get_yx_trends();
      }
    },
    clicksearchtype(index) {
      if (index == 1) {
        this.button1 = "new_button_check";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 1;
        // this.$set(this.form_filter2, "search_type", 1);
      }
      if (index == 2) {
        this.button1 = "new_button";
        this.button2 = "new_button_check";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 1;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 2;
        //this.$set(this.form_filter2, "search_type", 2)
      }
      if (index == 3) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button_check";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 1;
        this.is_year = 0;
        this.form_filter2.search_type = 3;
        //this.$set(this.form_filter2, "search_type", 3)
      }
      if (index == 4) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button_check";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 1;
        this.form_filter2.search_type = 4;
        //this.$set(this.form_filter2, "search_type", 4)
      }
      this.get_rl_trends();
    },
    web_shuaxin() {
      web_issue_order({
        did: this.did,
        tab_check: this.tab_check,
        device_type: 2
      }).then(res => {});
      //setTimeout(() => { this.iotdatalastget() }, 6000)
    },
    web_shuaxin2() {
      web_issue_order({
        did: this.did,
        tab_check: this.tab_check,
        device_type: 2
      }).then(res => {});
      setTimeout(() => {
        this.iotdatalastget();
      }, 6000);
    },
    change_tab2(name) {
      this.tab_check = name;
      //alert(this.tab_check)
      if (this.tab_check == "固件升级") {
        this.check_new();
        clearInterval(this.dingshi);
        clearInterval(this.progress_dingshi);
      } else if (
        this.tab_check == "PACK详情数据" ||
        this.tab_check == "汇总数据"
      ) {
        //alert(123)
        this.get_rl_trends();
        this.get_yx_trends();
      }
      if (this.tab_check != "固件升级") {
        clearInterval(this.dingshi);
        clearInterval(this.progress_dingshi);
        this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
      }

      if (name === "参数设置") {
        let vm = this;
        console.log("vm.$refs.control", vm.$refs.control);
        vm.$refs.control[0].clicktab();
      }
    },
    check_firmware() {},
    change_tab(name) {
      this.details_data = [];
      // this.caiyang_pinglv = [];
      // this.dui = [];
      // this.bingji = [];

      const didstr = name.split(" ");
      //alert(name);
      this.check_did = didstr[0];
      this.iotdatalastget(didstr[0]);
      debugger;
      if (name === "参数设置") {
        this.$refs.control.clicktab();
      }
    },
    nibianqi_change(value, type) {
      //   console.log(event)
      //  return
      config_nibianqi({ value: value, type: type, did: this.did }).then(res => {
        let msg = res.errorMsg;
        if (res.result === 0) {
          this.$Message.success(msg);
        } else {
          this.$Message.error(msg);
        }
      });
    }, //查看详情

    iotdatalastget(did) {
      // alert(1);
      // return;
      if (did) {
        this.did = did;
      } else {
        if (this.check_did) {
          this.did = this.check_did;
        } else {
          let q = this.$route.query;
          this.did = q.did;
        }
      }
      let bj_arr = [];
      for (let bj in this.bingji) {
        let bj_str = this.bingji[bj].split(" ");
        bj_arr.push(bj_str[0]);
      }
      let web_time = 0;
      console.log('SDAD',this.$route.query.web_time);
      if (this.$route.query.web_time != undefined) {
        web_time = parseInt(this.$route.query.web_time);
        this.is_web_time = 0;

        this.button1 = "new_button";
        this.button2 = "new_button_check";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 1;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 2;
        this.form_filter2.search_type = 2;
        this.form_filter2.search_date = formatYMD(
          parseInt(this.$route.query.web_time)
        );
      } else {
        web_time = 0;
        this.is_web_time = 1;
      }

      iotdatalastget({
        did: this.did,
        bingji: bj_arr,
        tab_check: this.tab_check,
        device_type: 2,
        web_time: web_time
      }).then(res => {
        get_now_lnglat({ did: this.did }).then(res1 => {
          this.deviclposition[0] = res1.body.lng;
          this.deviclposition[1] = res1.body.lat;
          console.log("resres", res1);
          this.loadMap(res1.body.lng, res1.body.lat);
          if (res.body.hasOwnProperty("历史轨迹")) {
            // 有历史估计，按经纬度显示地图
            console.log("中心点11", res1.body);
            this.qr_boolean = false;
            this.qr_boolean_click = true;
          } else {
            this.qr_boolean = true;
            this.qr_boolean_click = false;
            this.getQrCode(this.did, false);
          }
        });

//         if (res.body.汇总数据[0] != "nodata") {
//           this.battery = res.body.汇总数据.状态.find(
//             item => item.name_cn === "SOC"
//           ).value;
//           console.log("res.body.汇总数据[0]111", res.body.汇总数据.容量);
// const target = res.body.汇总数据.容量.find(item => item.name_cn === "累计充电容量");
// if (target) {
//   target.value = this.charge /10;
// }
// const target1 = res.body.汇总数据.容量.find(item => item.name_cn === "累计放电容量");
// if (target1) {
//   target1.value = this.discharge /10;
// }
//           this.SN = res.other.sn;
//           this.assign_time = res.other.assign_time;
//         }
        if (res.body.汇总数据[0] != "nodata") {
          this.battery = res.body.汇总数据.状态.find(
            (item) => item.name_cn === "SOC"
          ).value;
          this.SN = res.other.sn;
          this.assign_time = res.other.assign_time;
        }
        this.tableLoading = false;
        this.spinShow = false;

        this.tableDataList = [];
        if (res.result === 0) {
          var length = Object.keys(res.body).length;
          if (this.is_web_time == 1) {
            this.check_new();
          }
          // console.log(res)
          // return
          if (res.body["PACK详情数据"][0] != "nodata") {
            this.pack_data = res.body["PACK详情数据"];
            res.body["PACK详情数据"] = this.pack_data[this.pack_check - 1];
          }
          console.log("333", res.body["单体数据"]);
          if (
            !this.$route.query.web_time &&
            res.body["单体数据"][0] != "nodata"
          ) {
            this.pack_data_dt = res.body["单体数据"];
            console.log("111", this.pack_data_dt);
            //res.body['单体数据']=[]
            //res.body['单体数据'].splice(0, res.body['单体数据'].length)
            console.log("xiaoxie", this.pack_data_dt[this.pack_check - 1]);
            res.body["单体数据"] = {
              "": this.pack_data_dt[this.pack_check - 1]
            };
          }

          this.show_caiyang = true;
          this.details_data = res.body;
          console.log("单体数据222", res.body);
          this.caiyang_pinglv = res.other.caiyang_pinglv;
          this.dui = res.other.dui;
          this.chans = res.other.chans;
          if (res.other.chans.length == 1) {
            this.pack_check = 1;
          }
          this.bingji = res.other.bingji;

          //console.log("数据",res)

          //this.form_filter3.date=res.other.date
          console.log("this.$route.query.web_time", this.$route.query.web_time);
          this.form_filter3.date =
            this.$route.query.web_time != undefined
              ? formatYMD(parseInt(this.$route.query.web_time))
              : res.other.date;

          //this.rongliang_trends=res.other.rongliang_trends
          //循环找到逆变器
          this.zhexian(res);

          if (res.body["设备信息"]) {
            for (let i in res.body["设备信息"][""]) {
              let list = res.body["设备信息"][""][i];
              //console.log("aasdf"+list['name_cn'])
              if (list.type == "can_line") {
                //console.log(list['old'])
                this.can_lineData = list["old"];
                console.log("this.can_lineData", this.can_lineData);
              } else if (list.type == "chuan_line") {
                this.chuan_lineData = list["old"];
              } else if (list.type == "wang_line") {
                this.wang_lineData = list["old"];
              }
              if (list.name_en == "dcac_canid") {
                this.formModel.dcac_canid = list["old"];
                console.log(
                  "this.can_lineData",
                  typeof this.formModel.dcac_canid
                );
              } else if (list.name_en == "dcac_comid") {
                this.formModel.dcac_comid = list["old"];
              } else if (list.name_en == "dcac_netid") {
                this.formModel.dcac_netid = list["old"];
              }
            }
          }

          //设置发送刷新命令
          console.log(this.shuaxin);
          //(alert(1), 5000)
          if (this.is_web_time == 1) {
            setTimeout(() => {
              this.web_shuaxin();
            }, (this.shuaxin - 4) * 1000);
          }
          //this.$nextTick(() => {
          //   setTimeout(alert( (this.shuaxin - 2) * 1000), (this.shuaxin - 2) * 1000)
          // }) //this.web_shuaxin()
          // this.can_lineData =
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    /**
     * 升级固件
     */
    uploadFirmware(dp_chan) {
      let did = this.did;
      this.result_firmware = [];
      let vm = this;
      let config = {
        title: this.$t("升级"),
        loading: true,
        content: this.$t("您确定要升级通道") + dp_chan + this.$t("的固件吗？"),
        onOk: function() {
          let _this = this;
          upup_firmware({ did: did, dp_chan: dp_chan }).then(res => {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              _this.buttonLoading = false;
              // this.getFirmwareInfo()
              //拉取进度
              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0;
              // vm.progress_dingshi = setInterval(vm.progress, 5000);
              vm.progress_dingshi = setInterval(function() {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_yx_trends() {
      let pdata = {};
      if (this.chans != "" && this.tab_check != "汇总数据") {
        pdata = {
          did: this.did,
          date: this.form_filter3.date,
          dp_chan: this.pack_check
        };
      } else {
        pdata = {
          did: this.did,
          date: this.form_filter3.date
        };
      }

      get_yx_trends(pdata).then(res => {
        this.tableLoading = false;
        console.log("运行数据", res);
        this.alertTimeList3.splice(0);
        this.alertDataList3.splice(0);

        if (res.result === 0) {
          if (res.body.yunxing_trends && res.body.yunxing_trends.length > 0) {
            //趋势数据
            let tem1 = [];

            let tem3 = [];
            let tem4 = [];
            let tem5 = [];
            let tem6 = [];
            let tem7 = [];
            let tem8 = [];
            let tem9 = [];
            let tem10 = [];
            let x_axis = 0;
            let xzhou = [];

            for (let i = 0; i < res.body["yunxing_trends"].length; i++) {
              let list = res.body["yunxing_trends"][i];

              tem1.push(list["voltage"]);
              x_axis = list["timestamp"];
              xzhou.push(x_axis);

              // this.alertTimeList3.push(x_axis)
              tem3.push(list["current"]);
              tem4.push(list["soc"]);
              tem5.push(list["soh"]);
              tem6.push(list["remainder_capacity"]);
              tem7.push(list["max_single_voltage"]);
              tem8.push(list["min_single_voltage"]);
              tem9.push(list["max_temperature"]);
              tem10.push(list["min_temperature"]);
            }
            console.log("数据1", res.body);
            console.log("数据2", this.alertDataList3);

            this.alertTimeList3 = xzhou;

            // this.alertTimeList3=xzhou
            //  this.alertTimeList3 = xzhou

            this.alertDataList3.push({
              name: this.$t("Changelang.总电压") + "(v)",
              data: tem1,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#1400FF"
                  },
                  {
                    offset: 1,
                    color: "#C3BEFF" //'rgba(14,0,255,0.1)',
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.电流") + "(mA)",
              data: tem3,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#000000"
                  },
                  {
                    offset: 1,
                    color: "#cccccc"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.SOC") + "(%)",
              data: tem4,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#19741D"
                  },
                  {
                    offset: 1,
                    color: "#b7cbac"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.SOH") + "(%)",
              data: tem5,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#FF7D7D"
                  },
                  {
                    offset: 1,
                    color: "#f8c5bf"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.剩余容量") + "(Ah)",
              data: tem6,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#00C2FF"
                  },
                  {
                    offset: 1,
                    color: "#98dbec"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.最高电压") + "(mv)",
              data: tem7,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#52FF00"
                  },
                  {
                    offset: 1,
                    color: "#c7f2a3"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.最低电压") + "(mv)",
              data: tem8,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#FF8F8F"
                  },
                  {
                    offset: 1,
                    color: "#f8dcd5"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.最高温度") + "(°C)",
              data: tem9,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#FF00E5"
                  },
                  {
                    offset: 1,
                    color: "#f8c3e7"
                  }
                ])
              }
            });

            this.alertDataList3.push({
              name: this.$t("Changelang.最低温度") + "(°C)",
              data: tem10,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [
                  {
                    offset: 0,
                    color: "#00E0FF"
                  },
                  {
                    offset: 1,
                    color: "#AFE9EC"
                  }
                ])
              }
            });
          } else {
            //this.is_update=0
            //this.$Message.error("暂无可升级的固件")
          }
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    get_rl_trends() {
      let pdata = {};
      if (this.chans != "" && this.tab_check != "汇总数据") {
        pdata = {
          did: this.did,
          search_type: this.form_filter2.search_type,
          search_date: this.form_filter2.search_date,
          dp_chan: this.pack_check
        };
      } else {
        pdata = {
          did: this.did,
          search_type: this.form_filter2.search_type,
          search_date: this.form_filter2.search_date
        };
      }

      get_rl_trends(pdata).then(res => {
        this.tableLoading = false;
        this.rongliang_trends = [];
        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (
            res.body.rongliang_trends &&
            res.body.rongliang_trends.length > 0
          ) {
            this.rongliang_trends = res.body.rongliang_trends;
            this.xAxisData3.splice(0);
            this.legendData3.splice(0);
            this.seriesData3.splice(0);
            let xAxis3 = [];
            let xAxis3_1 = [];
            if (this.rongliang_trends && this.rongliang_trends.length > 0) {
              for (let j in this.rongliang_trends) {
                this.xAxisData3.push(this.rongliang_trends[j].x_axis);
                xAxis3.push(this.rongliang_trends[j].total_chongdian);
                xAxis3_1.push(this.rongliang_trends[j].total_fangdian);
              }
            }

            this.seriesData3.push(
              {
                name: this.$t("累计充电容量") + "(mAh)",
                type: "bar",
                tooltip: {
                  valueFormatter: function(value) {
                    return value + " mAh";
                  }
                },
                data: xAxis3
              },
              {
                name: this.$t("累计放电容量") + "(mAh)",
                type: "bar",
                tooltip: {
                  valueFormatter: function(value) {
                    return value + " mAh";
                  }
                },
                data: xAxis3_1
              }
            );
          } else {
            //this.is_update=0
            //this.$Message.error("暂无可升级的固件")
          }
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    //检测新的固件版本
    check_new(chan_id) {
      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({ did: this.did }).then(res => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (this.is_update === 0) {
              //  this.$Message.info("已经是最新版本")
            } else {
              //  this.$Message.success("检测出可升级的固件")
            }
            //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)
            console.log("res.body.firmware", res.body.firmware);
            this.firmware_list = res.body.firmware;
            if (chan_id == 0 || chan_id > 0) {
              this.$Message.success(this.$t("检测成功"));
            }
          } else {
            this.is_update = 0;
            //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    init() {
      this.shuaxin = 60;
      localStorage.setItem("shuaxin", this.shuaxin);
      this.spinShow = true;
      this.shuaxin = localStorage.getItem("shuaxin") || 10;
      //获取设备信息
      this.iotdatalastget();
      this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000);
      //setTimeout( this.web_shuaxin(), 2000 )
    },
    pinglvbox() {
      clearInterval(this.dingshi);
      this.modal7 = true;
    },
    changepinglv() {
      clearTimeout(this.pinglvdingshi);

      this.changepl = localStorage.getItem("changepl")
        ? localStorage.getItem("changepl")
        : 0;

      if (this.changepl == 0) {
        this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000);
      }

      // alert(123)
    },
    modal7cancel() {
      //debugger
      clearInterval(this.dingshi);
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
      clearTimeout(this.pinglvdingshi);
      this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000);
    },
    modal7Ok() {
      // debugger
      clearInterval(this.dingshi);
      //clearTimeout(this.pinglvdingshi)
      this.shuaxin = 3600;
      localStorage.setItem("shuaxin", this.shuaxin);
      localStorage.setItem("changepl", 1);
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
    },
    //刷新频率
    progress(dp_chan) {
      let did = this.did;
      progress_firmware({ did: did, dp_chan: dp_chan }).then(res => {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(() => {
              this.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          }
          // //拉取进度
          //this.is_jindu = 1;
          this.firmware_list[dp_chan].is_jindu = 1;
          if (res.body.jindu == 100) {
            clearInterval(this.progress_dingshi);
          }

          this.firmware_list[dp_chan].progress_percent = res.body.jindu;
          this.firmware_list[dp_chan].progress_text = res.body.ext_code;

          console.log(this.result_firmware);
          if (this.result_firmware.length >= 6) {
            let last = this.result_firmware.length - 1;
            if (
              this.result_firmware[last] == this.result_firmware[last - 1] &&
              this.result_firmware[last] == this.result_firmware[last - 2] &&
              this.result_firmware[last] == this.result_firmware[last - 3] &&
              this.result_firmware[last] == this.result_firmware[last - 4] &&
              this.result_firmware[last] == this.result_firmware[last - 5] &&
              this.result_firmware[last] == this.result_firmware[last - 6]
            ) {
              clearInterval(this.progress_dingshi);
              //this.$Message.error("固件升级超时，升级失败")
              this.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });
              this.check_new();
            }
          }
          this.result_firmware.push(res.body.jindu);
        } else {
          this.$Message.error(res.errorMsg);
          //this.is_jindu = 0;
          this.firmware_list[dp_chan].is_jindu = 0;
          //this.is_shengji = 1
          this.firmware_list[dp_chan].is_shengji = 1;
          //this.progress_percent = 0;
          this.firmware_list[dp_chan].progress_percent = 0;
          //this.progress_text = "";
          this.firmware_list[dp_chan].progress_text = "";
          clearInterval(this.progress_dingshi);
        }
        //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }
      });
    },
    refresh() {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: h => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  "刷新频率"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: evt => {
                      vm.$Modal.remove();
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(refreshCustom, {
              ref: "refreshCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                shuaxin: localStorage.getItem("shuaxin") || 10,
                parent_code: "0",
                parent_name: "无"
              }
            })
          ]);
        },
        onOk: function() {
          let _this = this;
          let obj = this.$refs.refreshCustom;
          obj.checkForm().then(res => {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success(vm.$t("设置成功"));
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin);

              //     vm.init()
            }
          });
          // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    more(title, morevalue) {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        okText: this.$t("关闭"),
        render: h => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },

                  this.$t("Changelang." + title)
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: evt => {
                      vm.$Modal.remove();
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(moreCustom, {
              ref: "moreCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                parent_code: "0",
                parent_name: "无",
                morevalue: morevalue
              }
            })
          ]);
        },
        onOk: function() {
          let _this = this;
          let obj = this.$refs.moreCustom;
          obj.checkForm().then(res => {
            if (res) {
              // vm.$Message.success("");
              vm.$Modal.remove();
              //vm.init()
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.success(config);
    },

    sampling() {
      //   alert(sampling)
      //  return;
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: h => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t("采样频率设置")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: evt => {
                      vm.$Modal.remove();
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(samplingCustom, {
              ref: "samplingCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                parent_code: "0",
                parent_name: "无",
                did: vm.did,
                caiyang_pinglv: this.caiyang_pinglv
              }
            })
          ]);
        },
        onOk: function() {
          let _this = this;
          let obj = this.$refs.samplingCustom;
          obj.checkForm().then(res => {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv({ ...obj.formModel }).then(res => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();

                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status);
    },
    reset() {
      this.form_filter = {
        tabname: null
      };
      let str = "";
      for (let i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = true;
      }
      // this.search()
    },
    search() {
      let str = "";
      for (let i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = false;
      }

      let xuhao = 0;
      for (let i in this.form_filter.tabname) {
        xuhao = parseInt(i) + 1;
        str = "" + "show1_" + xuhao;
        console.log(str);
        this[str] = true;
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          // alert('已复制: ' + text);
          this.$Message.success(this.$t("复制成功"));
        })
        .catch(err => {
          console.error("复制失败:", err);
        });
    },
    getQrCode(id, isChange) {
      if (this.qr_boolean_click) {
        get_qr_code({ did: id }).then(res => {
          if (res.result == 0) {
            this.qr_url = res.body.qrcode_url;
            this.qr_boolean = !this.qr_boolean;
          }
        });
        return;
      } else {
        get_qr_code({ did: id }).then(res => {
          if (res.result == 0) {
            this.qr_url = res.body.qrcode_url;
            if (isChange !== undefined) {
            }
          }
        });
      }
    },
    loadMap(lng, lat) {
      console.log("中心点", lng, lat);

      // let count_gj = this.pathList.length - 1;
      this.map = new AMap.Map("container", {
        zoom: 16, //级别
        center: [lng, lat] //中心点坐标 默认在杭州
      });
      var startIcon = new AMap.Icon({
        size: new AMap.Size(25, 34), // 图标尺寸
        image:
          "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png", // 图标的取图地址
        imageSize: new AMap.Size(135, 40), // 图标所用图片大小
        imageOffset: new AMap.Pixel(-9, -3) // 图标取图偏移量
      });

      // 创建一个 Marker
      var marker = new AMap.Marker({
        position: [lng, lat], // 图标位置
        icon: startIcon // 使用自定义图标
      });

      // 将 Marker 添加到地图
      marker.setMap(this.map);
      // 创建一个 Icon
      // var startIcon = new AMap.Icon({
      //   // 图标尺寸
      //   size: new AMap.Size(25, 34),
      //   // 图标的取图地址
      //   image:
      //     "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
      //   // 图标所用图片大小
      //   imageSize: new AMap.Size(135, 40),
      //   // 图标取图偏移量
      //   imageOffset: new AMap.Pixel(-9, -3),
      // });

      // 将 icon 传入 marker
      //   var startMarker = new AMap.Marker({
      //     map:this.map,
      //     position: new AMap.LngLat(this.pathList[0][0], this.pathList[0][1]),
      //     icon: startIcon,
      //     offset: new AMap.Pixel(-13, -30)
      //   });

      //         // 创建一个 icon
      // var endIcon = new AMap.Icon({
      //     size: new AMap.Size(25, 34),
      //     image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
      //     imageSize: new AMap.Size(135, 40),
      //     imageOffset: new AMap.Pixel(-95, -3)
      // });

      // // 将 icon 传入 marker
      //   var endMarker = new AMap.Marker({
      //     map:this.map,
      //     position: new AMap.LngLat(this.pathList[count_gj][0], this.pathList[count_gj][1]),
      //     icon: endIcon,
      //     offset: new AMap.Pixel(-13, -30)
      // });

      //       return new Promise((reslove, reject) => {
      //           //加载PathSimplifier，loadUI的路径参数为模块名中 'ui/' 之后的部分
      //           new AMapUI.load(['ui/misc/PathSimplifier'], PathSimplifier => {
      //               if (!PathSimplifier.supportCanvas) {
      //                   alert('当前环境不支持 Canvas！');
      //                   return;
      //               }
      //               if (this.pathList.length) {
      //                   //启动页面
      //                   this.initPage(PathSimplifier);
      //               }
      //           });

      //           reslove();
      //       });
    },
    getImageSrc(value) {
      console.log("valuevalue111", value);

      if (value >= 0 && value <= 10) {
        return require("@/assets/images/lowD.png");
      } else if (value >= 11 && value <= 30) {
        return require("@/assets/images/centerD.png");
      } else if (value >= 31 && value <= 60) {
        return require("@/assets/images/heightD.png");
      } else if (value >= 61 && value <= 100) {
        return require("@/assets/images/fullD.png");
      }
      return ""; // 默认值
    },
    swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    savepassword() {
      did_config_pass({ pass: this.password, did: this.did }).then(res => {
        if (res.result === 0) {
          let msg = res.errorMsg;
          vm.$Message.success(msg);
        } else {
          vm.$Message.error(msg);
        }
      });
    }
  },
  mounted() {
    const storedLang = localStorage.getItem("local");
    if (storedLang) {
      this.local = storedLang;
    }
    this.init()
    if (this.$route.query.web_time == undefined) {
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
    }
    let query = this.$route.query;
    if (query && query.tabname) {
      this.currDidTab = query.tabname;
    }
    // this.dingshi_shuaxin=setInterval(this.web_issue_order, this.shuaxin*1000);
  },
  destroyed() {
    clearInterval(this.dingshi);
    clearTimeout(this.pinglvdingshi);
    //localStorage.setItem('shuaxin', 60);
  },
  watch: {
    $route(to, from) {
      clearInterval(this.dingshi);
    }
  }
};
</script>
<style scoped>
.box {
  background: #fff;
  margin: 20px;
  padding: 10px;
}
.tab_inner {
  margin-top: 35px;
}
.formbox {
  z-index: 2;
}
.button_box {
  text-align: right;
}
.piliang {
  margin-right: 50px;
}
.TabPane {
  border-bottom: 1px solid #ccc;
}
.box {
  margin: 0;
  color: #7a7878;
}
.box div {
  margin-bottom: 5px;
}
.jiance {
  margin-left: 50px;
  margin-top: 10px;
}
.box2 {
  padding: 0 20px;
  background: white;
  width: 100%;
}
.button_box {
}
.piliang2 {
  position: absolute;
  right: 20px;
  z-index: 100;
  margin-top: -30px;
}
.span_data {
  float: right;
  margin-right: 15%;
  color: #000;
}
.dui_title {
  color: #2b85e4;
  font-size: 16px;
  margin-bottom: 30px;
}
.dui_box {
  padding: 10px;
}
.info_box {
  border: 1px solid #000;
  border-radius: 10px;
  padding: 10px;
  margin-top: 15px;
}
.battery_image {
  transform: rotate(-90deg);
  height: 40px;
  position: absolute;
  right: 30px;
  top: 5px;
}
.box .soc_box {
  margin-bottom: 30px;
  height: 55px;
  line-height: 55px;
}
.span_data2 {
  position: relative;
  font-weight: bold;
}
.info_box div {
  margin-top: 3px;
  margin-bottom: 3px;
}
.span_data3 {
  cursor: pointer;
}
.box .div_ota {
  margin-top: 10px;
  margin-bottom: 10px;
}
.button_search {
  text-align: right;
}
.button_search button {
  cursor: pointer;
  margin-right: 10px;
}
.new_button {
  border: 1px solid #000;
}
.new_button_check {
  border: 1px solid #000;
  background: #ccc;
}
.new_button:hover,
.new_button_check:hover {
  color: #000;
}
.yuandian {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #000;
  display: inline-block;
  margin-right: 5px;
}
.gengduobutton {
  border: 1px solid #000;
  border-radius: 10px;
  color: #000;
}
.gengduobutton:hover {
  color: #000;
}

::v-deep .ivu-select-selection {
  border-radius: 10px;
  border: 1px solid #000;
}
::v-deep tr th,
tr td {
  text-align: center;
  background: #fff;
}
::v-deep .ivu-table-cell {
  text-align: center;
  color: #000;
}
::v-deep .ivu-table-body {
  border-bottom: 1px solid #000;
}
::v-deep .ivu-table-header table {
  border: 1px solid #000;
}
::v-deep .ivu-table-body table {
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}

.tableContent {
  width: 1000px;
  height: 500px;

  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 35px 6px 20px;
}
.tableContent.tableContentInner {
  padding: 35px 6px 5px;
}
.topBottomTableContent {
  display: flex;
  flex-direction: column;
}

.tableContent /deep/ .ivu-spin-fix {
  background: transparent;
}

.tableContent /deep/ .ivu-table-row .ivu-table-cell-tree {
  background: transparent;
}
::v-deep .tab_inner .ivu-tabs-nav {
  border: 1px solid #000;
  border-radius: 5px;
  border-bottom: 2px solid #000;
}
::v-deep .tab_inner .ivu-tabs-tab-active {
  color: #000;
}
::v-deep .tab_inner .ivu-tabs-ink-bar {
  background: #000;
}
::v-deep .tab_inner .ivu-tabs-tab:hover {
  color: #000;
}
/* .ceshi_info{ width:100%;background:#ccc;overflow-y: scroll;}
.ceshi_info2{height:1000px;width:100%;background:#f00;overflow-y: scroll;} */

.tableContent {
  width: 100%;
  height: 500px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 35px 6px 20px;
}
.tableContent.tableContentInner {
  padding: 35px 6px 5px;
}
.topBottomTableContent {
  display: flex;
  flex-direction: column;
}

.tableContent /deep/ .ivu-spin-fix {
  background: transparent;
}

.tableContent /deep/ .ivu-table-row .ivu-table-cell-tree {
  background: transparent;
}
.info_box .div_ota {
  margin-top: 20px;
}
.progress_text {
  font-weight: bold;
}
.select_box {
  margin-top: 20px;
}
.deviceTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.deviceTitle div p {
  margin-top: 20px;
}
.deviceTitle div p .icon {
  font-size: 36px;
}
.icon {
  cursor: pointer; /* 鼠标悬浮时显示小手 */
  margin-left: 5px;
  transition: transform 0.2s; /* 添加过渡效果 */
}
</style>
